import { profile } from 'api';

export const handleResetPassword = async (token: string, companyId: string, password: string) => {
  await profile.post('/userlogin/changepassword', { token, companyId, password });
};
